import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_putaway_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    putaway_list_guid:fromDatatype.GuidDataFieldInterface;
    warehouse_guid:fromDatatype.GuidDataFieldInterface;
    layout_hdr_guid:fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid:fromDatatype.GuidDataFieldInterface;
    container_hdr_guid:fromDatatype.GuidDataFieldInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    container_scan_code :fromDatatype.VarcharDatatypeInterface;
    space_scan_code :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_wms_putaway_processing_queue_RowClass implements bl_wms_putaway_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    putaway_list_guid:fromDatatype.GuidDataFieldInterface;
    warehouse_guid:fromDatatype.GuidDataFieldInterface;
    layout_hdr_guid:fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid:fromDatatype.GuidDataFieldInterface;
    container_hdr_guid:fromDatatype.GuidDataFieldInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    container_scan_code :fromDatatype.VarcharDatatypeInterface;
    space_scan_code :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}